import { mailApiHeaders } from './mailApiHeaders';

/** 서버가 요청 행(본인 요청)에서 이름·이메일·소속·메모를 읽어 발송한다. */
export type SendBetaEventCodeRequestEmailParams = {
  requestId: string;
};

export type SendBetaEventCodeRequestEmailResult =
  | { ok: true; messageId?: string }
  | { ok: false; skipped?: boolean; error: string };

type ApiOk = { ok: true; messageId?: string };
type ApiErr = { ok: false; skipped?: boolean; code?: string; message?: string; error?: string };

function apiUrl(): string {
  const base = (process.env.REACT_APP_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';
  return base ? `${base}/api/send-beta-event-code-request-email` : '/api/send-beta-event-code-request-email';
}

/**
 * 베타 이벤트 코드 요청 내용을 운영 수신함(edukodi.info@gmail.com)으로 발송.
 * 동일 출처 `/api/send-beta-event-code-request-email` (Gmail SMTP / nodemailer).
 */
export async function sendBetaEventCodeRequestEmail(
  params: SendBetaEventCodeRequestEmailParams,
): Promise<SendBetaEventCodeRequestEmailResult> {
  try {
    const res = await fetch(apiUrl(), {
      method: 'POST',
      headers: await mailApiHeaders(),
      body: JSON.stringify(params),
    });

    let data: ApiOk | ApiErr | null = null;
    try {
      data = (await res.json()) as ApiOk | ApiErr;
    } catch {
      data = null;
    }

    if (!data || typeof data !== 'object') {
      return {
        ok: false,
        skipped: !res.ok,
        error: res.ok ? 'EMPTY_RESPONSE' : `HTTP_${res.status}`,
      };
    }

    if ('ok' in data && data.ok === true) {
      return { ok: true, messageId: (data as ApiOk).messageId };
    }

    const err = data as ApiErr;
    if (err.skipped) {
      return {
        ok: false,
        skipped: true,
        error: err.message ?? err.code ?? err.error ?? 'SKIPPED',
      };
    }
    return { ok: false, error: err.error ?? err.message ?? 'SEND_FAILED' };
  } catch (e) {
    return {
      ok: false,
      skipped: true,
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
